(function() {
    'use strict';
    angular
        .module('sigmasfApp')
        .factory('PurchaseItemLot', PurchaseItemLot);

    PurchaseItemLot.$inject = ['$resource'];

    function PurchaseItemLot ($resource) {
        var resourceUrl =  'api/purchase-item-lots/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
